import QuickBuyBar from './quickbuy-bar';

export function init() {
  import(/* webpackChunkName: "quickbuy", webpackMode: "lazy" */ './quickbuy').then(m => {
    // Quickbuy is initialised on import
  });

  // Handles quick buy bar and tire selector in it
  const barElement = document.querySelector<HTMLElement>('[data-quickbuy]');
  if (barElement) {
    new QuickBuyBar(barElement);
  }
}
